import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DraftFilterModal.module.css';

const STATUS_LIST = ['pending', 'rejected', 'approved', 'canceled'];

const postJson = (url) => fetch(url, {
    method: 'post',
    headers: { 'content-type': 'application/json' },
}).then(r => r.json());

// 체크박스 리스트 (team/category/status 공통)
function CheckboxList({ items, selected, onToggle, t }) {
    return items.map(({ key, value, label }) => (
        <div key={key}>
            <input
                type="checkbox"
                id={key}
                checked={selected.includes(value)}
                onChange={() => onToggle(value)}
            />
            <label htmlFor={key}>{t ? t(label) : label}</label>
        </div>
    ));
}

function DraftFilterModal({ show, onClose, onApply, filterType }) {
    const { t } = useTranslation();

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selected, setSelected] = useState([]); // team/category/status 공용
    const [teamList, setTeamList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    // 모달이 닫힐 때 또는 filterType 변경 시 선택 상태 리셋
    useEffect(() => {
        if (!show) return;
        setSelected([]);
        setStartDate('');
        setEndDate('');
    }, [show, filterType]);

    // 필터 타입별 데이터 로드
    useEffect(() => {
        if (filterType === 'team') {
            postJson('/api/getTeamList').then(setTeamList);
        } else if (filterType === 'category') {
            postJson('/api/getCategoryList').then(data => setCategoryList(data.map(i => i.draftCategory)));
        }
    }, [filterType]);

    const toggle = (value) => {
        setSelected(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
    };

    const handleApply = () => {
        const payloadMap = {
            date:     { startDate, endDate },
            team:     { selectedTeams: selected },
            category: { selectedCategories: selected },
            status:   { selectedStatuses: selected },
        };
        onApply(payloadMap[filterType]);
        onClose();
    };

    if (!show) return null;

    const titleMap = {
        date: '기간 설정',
        team: '팀 선택',
        category: '카테고리 선택',
        status: '승인 상태 선택',
    };

    return (
        <div className={styles.popupBackground} onClick={onClose}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.popupHeader}>
                    <span>{t(titleMap[filterType] || '')}</span>
                    <button className={styles.closeButton} onClick={onClose}>&times;</button>
                </div>

                <div className={styles.popupBody}>
                    {filterType === 'date' && (
                        <>
                            <label>{t('시작 날짜')}</label>
                            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                            <label>{t('종료 날짜')}</label>
                            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                        </>
                    )}

                    {filterType === 'team' && (
                        <>
                            <label>{t('팀명')}</label>
                            <CheckboxList
                                items={teamList.map(team => ({ key: team.teamId, value: team.teamName, label: team.teamName }))}
                                selected={selected}
                                onToggle={toggle}
                            />
                        </>
                    )}

                    {filterType === 'category' && (
                        <>
                            <label>{t('카테고리')}</label>
                            <CheckboxList
                                items={categoryList.map(c => ({ key: c, value: c, label: c }))}
                                selected={selected}
                                onToggle={toggle}
                                t={t}
                            />
                        </>
                    )}

                    {filterType === 'status' && (
                        <>
                            <label>{t('승인 상태')}</label>
                            <CheckboxList
                                items={STATUS_LIST.map(s => ({ key: s, value: s, label: s }))}
                                selected={selected}
                                onToggle={toggle}
                                t={t}
                            />
                        </>
                    )}
                </div>

                <div className={styles.popupFooter}>
                    <button onClick={onClose}>{t('취소')}</button>
                    <button onClick={handleApply}>{t('적용')}</button>
                </div>
            </div>
        </div>
    );
}

export default DraftFilterModal;